import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import FlashOfferListingCell from '@/onenetwork/components/datatable/FlashOfferListingCell.vue'
import FlashOfferStatistic from '@/onenetwork/components/datatable/FlashOfferStatistic.vue'
import FlashOfferDeal from '@/onenetwork/components/datatable/FlashOfferDeal.vue'
import { FlashOfferAPI } from '../constants/flashoffer.api.uri.const'
import { buildFilterObject } from '@/utils/filter'
import { formatTableDataFlashOfferResult } from '../helper/table'
import {markRaw} from 'vue'


export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum FlashOfferResultActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface FlashOfferResultStore {
  action_type: FlashOfferResultActionTypes,
  action_mess: string,
  uuid: string,
  data: Object,
  filter: Array<{
    key: string,
    type: string,
    label: string,
    placeholder: string,
    value: any,
    options?: Array<{label: string, value: string}>
  }>,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useFlashOfferResultStore = defineStore('flash_offer.result', {
  state: (): FlashOfferResultStore => ({
    action_type: FlashOfferResultActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'completed_end',
        type: 'date-range',
        label: 'Lọc theo ngày hoàn thành',
        placeholder: 'Chọn ngày hoàn thành',
        value: '',
        options: {
          showTime: true,
        }
      },
      {
        key: 'province_id',
        type: 'region-level-1',
        label: 'Lọc theo tỉnh/thành',
        placeholder: 'Chọn tỉnh / thành',
        value: '',
        options: null,
      },
      {
        key: 'ward_id',
        type: 'region-level-2',
        label: 'Lọc theo phường / xã',
        placeholder: 'Chọn phường xã',
        value: '',
        options: null,
      },
      {
        key: 'keyword',
        type: 'taginput',
        label: 'Lọc theo từ khoá',
        placeholder: 'Nhập từ khoá',
        value: '',
      },
      {
        key: 'flash_offer_code',
        type: 'text',
        label: 'Lọc theo mã FO',
        placeholder: 'Nhập mã FO',
        value: '',
      },
      {
        key: 'bid_code',
        type: 'text',
        label: 'Lọc theo mã BID',
        placeholder: 'Nhập mã BID',
        value: '',
      },

    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Kết quả chốt deal',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        id: { label: 'ID', component: markRaw(TextCell), class: '', visible: true, sort: 'desc', config: {} },
        subject: { label: 'Sản phẩm mở bán', component: markRaw(FlashOfferListingCell), class: '', visible: true, sort: false, config: {} },
        statistic: { label: 'Thống kê', component: markRaw(FlashOfferStatistic), class: 'w-[300px]', visible: true, sort: false, config: {} },
        deal: { label: 'GD thành công', component: markRaw(FlashOfferDeal), class: '', visible: true, sort: false, config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    }
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Kết quả chốt deal',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.action_type = FlashOfferResultActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    resetFilter () {
      this.filter = this.filter.map((item: {key: string}) => {
        return { ...item, value: '' }
      })
      this.action_type = FlashOfferResultActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    changeFilter (key: string, value: any) {
      const filterItem = this.filter.find((item: {key: string}) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.action_type = FlashOfferResultActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },
    putFilter(key: string, value: any) {
      this.filter = this.filter.map((field) => {
        if (field.key === key) {
          return { ...field, value: value }
        }
        return field
      })
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = FlashOfferResultActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.action_type = FlashOfferResultActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList(){
      return new Promise(async (resolve, reject) => {
        try{
          this.action_type = FlashOfferResultActionTypes.FETCHING
          const sort = this.sortFilter
          const pagination = {
            page: this.page,
            page_size: this.pageSize,
            sort,
            status: ['success'],
          };

          const filter = buildFilterObject(this.filter, pagination);
          const res: any = await APIClient.get(FlashOfferAPI.flashoffer.result, {
            params: filter
          })

          const { data } = res.data;

          this.data = {
            list: formatTableDataFlashOfferResult(data.data) || [],
            totalRecords: data.total ?? 0,
            totalPage: data.last_page ?? 0
          }
          this.action_type = FlashOfferResultActionTypes.FETCH_SUCCESS
          resolve(data);


        } catch (e) {
          this.action_type = FlashOfferResultActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
